module.exports = __webpack_public_path__ + "static/img/slider-dev.2973a65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/color-theme/img/slider/slider-dev.png
// module id = /s/k
// module chunks = 1